import Hub from '../hub.js';
import EventDelegate from '../utils/event-delegate.js';

const Likes = (function (DM) {
    'use strict';

    /**
     * Storage Manager
     */

    var StorageManager = (function () {
        return {
            data: [],
            add: function (item) {
                this.read().push(item);
                this.save();
            },
            remove: function (item) {
                this.read();
                if (this.data.indexOf(item) >= 0) {
                    this.data.splice(this.data.indexOf(item), 1);
                }
                this.save();
            },
            count: function () {
                this.read();
                return this.data.length;
            },
            read: function () {
                try {
                    var item = localStorage.getItem(this.key);
                    if (item) {
                        this.data = JSON.parse(localStorage.getItem(this.key));
                    } else {
                        this.save();
                    }
                    return this.data;
                } catch (e) {
                    return null;
                }
            },
            save: function () {
                try {
                    localStorage.setItem(this.key, JSON.stringify(this.data));
                    return this.data;
                } catch (e) {
                    return null;
                }
            },
            erase: function () {
                try {
                    localStorage.removeItem(this.key);
                } catch (e) {
                    return null;
                }

                return true;
            },
            init: function (key) {
                this.key = key;
                return this;
            }
        };
    }(window.DM));

    /**
     * Heart Module
     */

    var settings = {
        selector: '.js-like',
        selectorLabel: '.js-like__count',
        storageKey: 'likes',
        clsLiked: 'is-liked',
        label: '',
        attrs: {
            type: 'data-like-type',
            likeId: 'data-like-id',
            liked: 'data-like-liked',
            likeCount: 'data-like-count'
        }
    };

    /**
     * Like View
     */

    var LikeView = {
        like: function () {
            this.liked = true;
            this.el.classList.add(settings.clsLiked);
            this.el.setAttribute(settings.attrs.liked, this.liked);
        },
        unlike: function () {
            this.liked = false;
            this.el.classList.remove(settings.clsLiked);
            this.el.setAttribute(settings.attrs.liked, this.liked);
        },
        init: function (options) {
            this.idx = options.idx;
            this.id = options.id;
            this.liked = options.liked;
            this.count = options.count;
            this.type = options.type;
            this.el = options.el;

            return this;
        }
    };

    /**
     * Like Module
     */

    var Likes = {
        isAuthorized: function () {
            return DM.Config.userIsLoggedIn;
        },
        getLikeElements: function (id) {
            return this.getCollection().filter(v => v.id === id)
        },
        getCollection: function () {
            var items = [...document.querySelectorAll(settings.selector)].map(function (el, idx) {
                var item = Object.create(LikeView).init({
                    idx: idx,
                    el: el,
                    id: el.getAttribute(settings.attrs.likeId),
                    type: el.getAttribute(settings.attrs.type),
                    liked: el.getAttribute(settings.attrs.liked) === 'true' ? true : false,
                    count: parseInt(el.getAttribute(settings.attrs.likeCount)) || 0
                });
                return item;
            });
            return items;
        },
        getUserLikes: function (collection) {
            return new Promise((resolve, reject) => {
                const ids = collection.map(v => v.id);

                if (this.isAuthorized()) {
                    this.service.getUserLikes(ids).then(function (r) {
                        resolve(r);
                    });
                } else {
                    resolve(this.storage.read());
                }
            });
        },

        setLikes: function (likes) {
            if (Array.isArray(likes)) {
                likes.forEach(function (id) {
                    this.getLikeElements(id).forEach(function (item) {
                        item.like();
                    });
                }.bind(this));
            }
        },

        addLike: function (elements) {
            const element = elements[0];
            if (this.isAuthorized()) {
                elements.forEach((el) => el.like());
                Hub.publish(Hub.LIKE_ADD, element);
            }
            this.service.like(element.id).then((res) => {
                if (!this.isAuthorized()) {
                    if (res.Added) {
                        elements.forEach((el) => el.like());
                        this.storage.add(elements[0].id);
                        Hub.publish(Hub.LIKE_ADD, element);
                    } else {
                        Hub.publish(Hub.ACCOUNT_SHOW_LOGIN, {
                            msg: 1,
                            action() {
                                this.addLike([element]);
                            }
                        });
                    }
                }
            });
        },

        removeLike: function (elements) {
            if (this.isAuthorized()) {
                elements.forEach(function (el) {
                    el.unlike();
                });
            }

            this.service.unlike(elements[0].id).then(function () {
                if (!this.isAuthorized()) {
                    elements.forEach(function (el) {
                        el.unlike();
                    });
                    this.storage.remove(elements[0].id);
                }
            }.bind(this));

            Hub.publish(Hub.LIKE_REMOVE, elements[0]);
        },

        handleAddLike: function (e, obj) {
            this.addLike([obj]);
        },

        handleClick: function (e) {
            var id = e.currentTarget.getAttribute(settings.attrs.likeId);
            var elements = this.getLikeElements(id);

            if (elements[0].liked) {
                this.removeLike(elements);
            } else {
                this.addLike(elements);
            }

            e.originalEvent.preventDefault();
        },

        update: function (collection) {
            this.getUserLikes(collection).then(this.setLikes.bind(this));
            if (this.isAuthorized()) {
                this.storage.erase();
            }
        },

        handleUpdate: function () {
            var collection = this.getCollection();
            this.update(collection);
        },

        subscribe: function () {
            Hub.subscribe(Hub.HTML_UPDATE, this.handleUpdate.bind(this));
        },

        events: function () {
            const delegate = new EventDelegate(document);
            delegate.on('click', settings.selector, this.handleClick.bind(this));
        },

        init: function () {
            this.service = DM.Service.Likes;
            this.storage = Object.create(StorageManager).init(settings.storageKey);
            this.subscribe();
            this.events();
            this.collection = [];
            this.handleUpdate();
        }
    };

    /**
     * Initialize
     */

    var likes = Object.create(Likes);

    likes.init();

    return likes;

})(window.DM);

export default Likes;
